
const MomoConstants = {
    CATEGORY_INFO: [
        {id: 1, name: '영상'},
        {id: 2, name: '리뷰'},
        {id: 99, name: '스페셜'},
    ]
};

export default MomoConstants;